import React, { useEffect } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Provider as ReduxProvider } from "react-redux";

import { store } from './redux/store';
import { OnlineMain } from './OnlineMain';

import './App.scss';
import { UiModals } from './components/Modals/UiModals';
import { env } from './env';

function OnlineApp() {
    useEffect(() => {
        if (env().REACT_APP_CHAT_WIDTH?.length > 0) {
            document.documentElement.style.setProperty('--chat-width', env().REACT_APP_CHAT_WIDTH)
        }
    }, []);
    return <ReduxProvider store={store}>
        <UiModals />
        <BrowserRouter>
            <Routes>
                <Route
                    path="*"
                    element={<OnlineMain />}
                />
            </Routes>
        </BrowserRouter>
        <ToastContainer/>
    </ReduxProvider>;
}

export default OnlineApp;